export default __webpack_public_path__ + "static/media/003-corn.f65b7539.svg";